import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import ApiCallServices from "../../../../../services/ApiCallServices";
import { END_POINTS } from "../../../../../services/endpoint/endPoint";
import button from "../../../../button.module.css";
import DspList from "./child/DspList";

const Dsp = () => {
  const initialState = {
    name: "",
    key: "",
  };

  const [selectedPrevillage, setSelectedPrevillage] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [newDsp, setNewDsp] = useState(initialState);
  const [search, setSearch] = useState("");
  const [dspRole, setDspRole] = useState([]);
  const [selectedDspRole, setSelectedDspRole] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [showHideModal, setShowHideModal] = useState(false);
  const [showHideModal1, setShowHideModal1] = useState(false);
  const [loader, setLoader] = useState(false);
  const [sortingColumn, setSortingColumn] = useState(null);
  const [sortingOrder, setSortingOrder] = useState("asc");

  const updateStatus = async (id, status) => {
    try {
      const res = await ApiCallServices.create(END_POINTS.updateDspStatus, {
        id,
        status,
      });

      if (res.status === 200) {
        toast.success(res.data.message || "Status updated", {
          position: "top-right",
        });
        getDspsTableData();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to update status", {
        position: "top-right",
      });
    }
  };

  const getDsp = async (id) => {
    try {
      const res = await ApiCallServices.getlisting(
        `${END_POINTS.getDspById}/${id}`
      );
      if (res.status === 200) {
        const { dsp_key, name } = res.data?.data;

        setNewDsp({
          dsp_key: dsp_key || "",
          name: name || "",
          id,
        });
        setIsEditMode(true);
        setShowHideModal(true);
        document.body.style = "overflow: hidden";
      }
    } catch (error) {
      toast.error("Failed to fetch dsp details", {
        position: "top-right",
      });
    }
  };

  const getDspsTableData = async () => {
    setLoader(true);
    const data = {
      name: search,
      dspType: selectedDspRole?.id,
      sortingcolumn: sortingColumn,
      sortingorder: sortingOrder,
    };
    try {
      const res = await ApiCallServices.create(END_POINTS.dspsTableData, data);
      if (res.status === 200) {
        setTableData(res.data.data);
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Error fetching data", {
        position: "top-right",
      });
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getDspsTableData();
  }, [search, selectedDspRole, sortingColumn, sortingOrder]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setNewDsp({ ...newDsp, [name]: value });
  };

  const validateForm = (prev) => {
    const errors = {};
    if (!newDsp?.dsp_key) errors.dsp_key = "Key is required";
    if (!newDsp?.name) errors.name = "Name is required";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const prev = selectedPrevillage.map((item) => item.value);
    if (!validateForm(prev)) return;

    const obj = { ...newDsp, privilege: prev };

    try {
      const res = isEditMode
        ? await ApiCallServices.create(END_POINTS.updateDsp, obj)
        : await ApiCallServices.create(END_POINTS.createDsp, obj);

      if (res.status === 200) {
        toast.success(res.data.message, { position: "top-right" });
        resetForm();
        getDspsTableData();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Operation failed", {
        position: "top-right",
      });
    }
  };

  const resetForm = () => {
    setIsEditMode(false);
    setNewDsp(initialState);
    setSelectedPrevillage([]);
    setShowHideModal(false);
    document.body.removeAttribute("style");
    setErrors({});
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
      <div className='filter-wraper justify-content-between'>
          <div className='d-flex align-items-center fields'>
              <h3>Manage DSP</h3>
          </div>
      </div>

        <div className="filter-wraper d-flex justify-content-between">
          <div className="d-flex align-items-center fields">
            <div className="form-group search-icon">
              <input
                type="text"
                className="form-control"
                onChange={(e) =>
                  setSearch(e.target.value.length > 1 ? e.target.value : "")
                }
                placeholder="Search dsp"
              />
            </div>
          </div>
          <div className="form-group d-flex justify-content-end">
            <button
              type="button"
              className={`${button.btn} ${button.btnDarkBlue}`}
              onClick={() => {
                setShowHideModal(true);
                document.body.style = "overflow: hidden";
              }}
            >
              Add New DSP
            </button>
          </div>
        </div>

        <DspList
          tableData={tableData}
          getDsp={getDsp}
          updateStatus={updateStatus}
          loader={loader}
          search={search}
          sortingColumn={sortingColumn}
          sortingOrder={sortingOrder}
          onSort={(col) => {
            setSortingColumn((prevCol) => (prevCol === col ? col : col));
            setSortingOrder((prevOrder) =>
              sortingColumn === col
                ? prevOrder === "asc"
                  ? "desc"
                  : "asc"
                : "asc"
            );
          }}
        />
      </div>

      <div className={`modal form-modal ${showHideModal ? "show" : ""}`}>
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {isEditMode ? "Update DSP" : "Create New DSP"}
              </h4>
              <i
                className="fa-regular fa-circle-xmark close-icon"
                onClick={resetForm}
              ></i>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="form-wraper">
                  <div className="form-group">
                    <label>
                      Key <span className="astric">*</span>
                    </label>
                    <input
                      placeholder="Enter Key"
                      name="dsp_key"
                      value={newDsp.dsp_key}
                      onChange={handleInput}
                      className="form-control"
                    />
                    {errors?.dsp_key && (
                      <div className="input-error">{errors.dsp_key}</div>
                    )}
                  </div>

                  <div className="form-group">
                    <label>
                      Name <span className="astric">*</span>
                    </label>
                    <input
                      placeholder="Enter Name"
                      name="name"
                      value={newDsp.name}
                      onChange={handleInput}
                      className="form-control"
                    />
                    {errors?.name && (
                      <div className="input-error">{errors.name}</div>
                    )}
                  </div>

                  <div className="text-end">
                    <button
                      type="submit"
                      className={`${button.btn} ${button.btnBlue}`}
                    >
                      {isEditMode ? "Update" : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${showHideModal || showHideModal1 ? "overlay" : ""}`}
      ></div>
    </>
  );
};

export default Dsp;
